import { render, staticRenderFns } from "./lecturerManager.vue?vue&type=template&id=9f599e40"
import script from "./lecturerManager.vue?vue&type=script&lang=js"
export * from "./lecturerManager.vue?vue&type=script&lang=js"
import style0 from "./lecturerManager.vue?vue&type=style&index=0&id=9f599e40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports